import * as React from 'react';

export const MobileContext = React.createContext<boolean>(false);
